/**
 * `F4` · El código que el comensal enseña en el mostrador —
 * `Flujo-de-mostrador.md`, y migración 058.
 *
 * Camila toca «Mostrar mi código» y ve seis caracteres grandes y un QR con lo
 * mismo. La cajera escanea, o los teclea si la cámara no enfoca. **Vive tres
 * minutos y se usa una sola vez.**
 *
 * ── Por qué efímero, y no el identificador de su membresía ────────────────
 * Un identificador estable en pantalla es una credencial al portador: una
 * captura compartida por WhatsApp dejaría que otra persona **canjee** el premio
 * ajeno. Sellar de más es inofensivo —el negocio regala un café—; canjear no,
 * porque se lleva algo que otro pagó con sus visitas.
 *
 * ── Y por qué seis caracteres bastan ──────────────────────────────────────
 * Con 29 símbolos son 29⁶ ≈ **5.9 × 10⁸** combinaciones. Contra una ventana de
 * tres minutos y un solo uso, adivinar no es un ataque: es esperar. Lo corto no
 * lo sostiene la longitud, lo sostiene que caduque — y por eso las dos cosas
 * viven juntas en este archivo y no en dos sitios que puedan desincronizarse.
 */
import { ALFABETO_DEL_CODIGO, generarCodigo } from './codigo-de-qr.js';
/** Seis. Ver la cabecera: lo que lo hace seguro es la caducidad, no el largo. */
export const LARGO_DEL_CODIGO_DE_TARJETA = 6;
/**
 * Tres minutos, en segundos.
 *
 * El mismo número vive además en un `check` de la migración 058, que es quien
 * de verdad lo impide: si esta constante creciera a tres horas, el motor
 * rechazaría la fila en vez de dejar un código de un día en la pantalla de
 * alguien. Hay una prueba que compara los dos.
 */
export const VIDA_DEL_CODIGO_SEGUNDOS = 3 * 60;
/** Un código de tarjeta nuevo. Mismo alfabeto y mismo descarte que el del papel. */
export const generarCodigoDeTarjeta = (aleatorio) => generarCodigo(aleatorio, LARGO_DEL_CODIGO_DE_TARJETA);
/**
 * ¿Tiene forma de código de tarjeta? **No dice si existe**, sólo si vale la pena
 * buscarlo — igual que `esCodigoPosible` para el papel de la mesa.
 *
 * Lo usa el mostrador antes de tocar la base: lo que llega ahí lo teclea una
 * persona con la fila esperando, y una cadena que no puede ser un código no
 * merece un viaje a la base ni una fila de registro.
 */
const FORMA_DE_TARJETA = new RegExp(`^[${ALFABETO_DEL_CODIGO}]{${LARGO_DEL_CODIGO_DE_TARJETA}}$`);
export const esCodigoDeTarjetaPosible = (valor) => FORMA_DE_TARJETA.test(valor);
//# sourceMappingURL=codigo-de-tarjeta.js.map